<tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
